import React from 'react';
import './Page_received_matched_gift.css';
import Apply_gift from '../Apply_gift/Apply_gift';
import Redemption_details from '../Redemption_details/Redemption_details';

import GGApi from '../../../utils/GGApi.js';
import dates from '../../../utils/dates.js';
import GG_confetti from '../../general_components/GG_confetti/GG_confetti';
import GG_loader from '../../general_components/GG_loader/GG_loader';
import Overlay_popup from '../../general_components/Overlay_popup/Overlay_popup';
import { Link } from 'react-router-dom';

import config from '../../../utils/config';
import amplitude from 'amplitude-js';
import { Helmet } from 'react-helmet';
amplitude.getInstance().init(config.amp_key);

class Page_received_matched_gift extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            show_confetti: false,
            redeem_status: '',
            access: '',
            gift_status: '',
            recipients: [],
            applied_for: '',
            applied_to: '',
            applied_on: '',
            finish_open: false,
            gift: {},
            matcherName: null,
            matcherRelationship: null,
        };
        this.showError = this.showError.bind(this);
    }

    componentDidMount() {
        GGApi.received_matched_gift(this.props.match.params.id).then(result => {
            if (result.access === 'No-access') {
                this.setState({ access: result.access, loading: false });
                return;
            }
            const requestedGift = result.requestedGift;
            this.setState({
                gift: requestedGift,
                redeem_status: requestedGift.redeem_status || '',
                matcherName: result.matcherName,
                matcherRelationship: result.matcherRelationship,
            });
            if (requestedGift.delivery_date) {
                requestedGift.delivery_date = dates.jsDate(requestedGift.delivery_date);
            }
            if (requestedGift.redemption_date) {
                GGApi.redeemed_gift(this.props.match.params.id).then(res => {
                    if (res.applied_on) {
                        this.setState({
                            gift_status: 'Redeemed',
                            applied_for: res.applied_for,
                            applied_to: res.applied_to,
                            applied_on: dates.jsDate(res.applied_on),
                            loading: false,
                        });
                    } else {
                        this.setState({ gift_status: 'Redeemed', loading: false });
                    }
                });
            } else {
                GGApi.get_recipient_accounts().then(res => {
                    if (res.success) {
                        const recipients = res.recipients.map(r => ({ id: r.id, title: r.account_name }));
                        this.setState({ recipients, gift_status: 'new', loading: false });
                    } else {
                        this.setState({ gift_status: 'new', loading: false });
                    }
                });
            }
        });
    }

    showError() {
        this.setState({ redeem_status: 'failed' });
    }

    render() {
        if (this.state.access === 'No-access') {
            return (
                <main>
                    <h2>We're sorry, but the page you are trying to locate is unavailable.</h2>
                </main>
            );
        }
        if (this.state.loading) return <GG_loader />;

        const gift = this.state.gift;
        const giftAmount = gift.gift_amount - (1 - (gift.accepted_fees || 1)) * (gift.gift_send_fee || 0);

        return (
            <div>
                {this.state.gift_status === 'new' && this.state.show_confetti && !this.state.finish_open ? <GG_confetti /> : null}
                <main>
                    <Helmet>
                        <title>Matched Gift | Greatest Gift</title>
                        <meta name="description" content="Redeem your matched gift." />
                    </Helmet>

                    {this.state.redeem_status === 'failed' ? (
                        <p className="gg_red">We're sorry, but there was an issue when trying to redeem this gift. Please contact our support team for additional details.</p>
                    ) : null}

                    {this.state.gift_status === 'new' && !this.state.finish_open ? (
                        <Apply_gift
                            received_gift_status={this.state.gift_status}
                            recipients={this.state.recipients}
                            defaultAccountId={gift.account_id}
                            openGuideOnMount={false}
                            updateActiveRecipient={this.props.updateActiveRecipient}
                            gift_id={gift.gift_id || gift.id}
                            toggle_loading={() => this.setState({ loading: !this.state.loading })}
                            open_finish={() => this.setState({ finish_open: true })}
                            showError={this.showError}
                            redeem_status={this.state.redeem_status}
                            new_receiver={this.props.new_receiver}
                            Gift_amount={giftAmount}
                            show_confetti={() => this.setState({ show_confetti: true })}
                            thank_you_sent={false}
                            buttonText="Redeem Matched Gift"
                        />
                    ) : null}

                    <Overlay_popup
                        open={this.state.finish_open}
                        overlay_title="Your matched gift is being redeemed!"
                        wide={true}
                        body_1="Your matched gift is scheduled to be redeemed. The gift funds will appear in the selected financial account in a few days."
                        button_1={{ text: 'Finish', links: true, linkTo: '/receive' }}
                    />

                    <h2>Gift Details</h2>
                    <div className="two_column_text_container">
                        <div className="two_column_line">
                            <div className="left_column_text"><p>Gift for:</p></div>
                            <div className="right_column_text"><p>{gift.gift_for}</p></div>
                        </div>
                        <div className="two_column_line">
                            <div className="left_column_text"><p>Source:</p></div>
                            <div className="right_column_text"><p>Gift matching</p></div>
                        </div>
                        <div className="two_column_line">
                            <div className="left_column_text"><p>Received On:</p></div>
                            <div className="right_column_text"><p>{gift.delivery_date}</p></div>
                        </div>
                        <div className="two_column_line">
                            <div className="left_column_text"><p>Gift Amount:</p></div>
                            <div className="right_column_text"><p>${giftAmount}</p></div>
                        </div>
                    </div>

                    <h2>Matching Details</h2>
                    <div className="two_column_text_container">
                        <div className="two_column_line">
                            <div className="left_column_text"><p>Matching by:</p></div>
                            <div className="right_column_text"><p>{this.state.matcherName && this.state.matcherRelationship ? `${this.state.matcherName} (${this.state.matcherRelationship})` : this.state.matcherName || this.state.matcherRelationship || 'Matcher'}</p></div>
                        </div>
                       
                    </div>

                    <Redemption_details
                        received_gift_status={this.state.gift_status}
                        gift_redeemed_for_child_account={this.state.applied_for}
                        gift_id={gift.gift_id || gift.id}
                        redemption_date={this.state.applied_on}
                        redeemed_at_financial_account={this.state.applied_to}
                        redeem_status={this.state.redeem_status}
                    />

                    <div className="buffer"></div>
                </main>
            </div>
        );
    }
}

export default Page_received_matched_gift;
